import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StatesUIHelpers";

const StatesUIContext = createContext();

export function useStatesUIContext() {
  return useContext(StatesUIContext);
}

export const StatesUIConsumer = StatesUIContext.Consumer;

export function StatesUIProvider({ statesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newStateButtonClick: statesUIEvents.newStateButtonClick,
    openEditStatePage: statesUIEvents.openEditStatePage,
    openDeleteStateDialog: statesUIEvents.openDeleteStateDialog,
    openDeleteStatesDialog: statesUIEvents.openDeleteStatesDialog,
    openFetchStatesDialog: statesUIEvents.openFetchStatesDialog,
    openUpdateStatesStatusDialog:
    statesUIEvents.openUpdateStatesStatusDialog,
  };

  return (
    <StatesUIContext.Provider value={value}>
      {children}
    </StatesUIContext.Provider>
  );
}
